export default {
    'about.company.h1':'公司简介',
    'about.company.p1':'达强（深圳）国际物流有限公司（以下简称达强）是国内领先的多式贸易和物流联运公司。公司总部设在深圳； 主要提供往返于亚洲、美洲和欧洲之间的综合完善的贸易和物流服务。',
    'about.company.p2':'公司在中国(北京、深圳、香港)、俄罗斯、哈萨克斯坦、和乌克兰设有办事处；并在波兰、意大利和美国设有代理商。 在中、美、欧以及独联体地区建立了完善的自营服务网点和代理网络。',
    'about.company.p3':'达强致力于为客户提供端到端的解决方案，提供具有竞争力和整体成本效益的贸易和物流服务。 达强的贸易和物流服务涵盖公路、铁路、海运、航空等多种运输方式。公司并提供清关服务，能够办理报关、国内、国际清关等所有手续。 此外，公司还提供细致的端到端服务，例如卡车或飞机的最新班次/预订，工程项目贸易和物流，展会货物物流，包租承运人，多种联运服务（如公路、铁路加海运）等； 同时，达强还可提供仓储以及供应链管理服务。',
    'about.company.p4':'公司同时经营商贸业务，包括机电产品、消费品、原材料、半成品组件、轻重型汽车等。公司已有十多年经营历史，有良好的客户关系、业务渠道和资源。 凭借专业的服务和丰富的经验，为客户提供高质量、高性价比的采购和商贸服务，并且整合物流业务提供包括生产工艺认证、质检、包装、物流等一条龙方案服务。',
    'about.company.h2':'优质的服务',
    'about.company.list.first':'解决国内及国外客户的报关、清关难的问题',
    'about.company.list.second':'精准的航班服务、承包工程项目物流、展会物流',
    'about.company.list.third':'多式联运、联储、采购及供应链管理等端到端的定制服务',
    'about.company.list.fourth':'优质的采购资源整合能力及服务',
}